import { render } from "./DeviceNavigatorEditorCmp.vue?vue&type=template&id=9bf064d4&scoped=true"
import script from "./DeviceNavigatorEditorCmp.vue?vue&type=script&lang=js"
export * from "./DeviceNavigatorEditorCmp.vue?vue&type=script&lang=js"

import "./DeviceNavigatorEditorCmp.vue?vue&type=style&index=0&id=9bf064d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf064d4"]])

export default __exports__